<template>
  <div
    class="container-fluid d-flex align-items-center justify-content-between"
  >
    <!-- begin:: Header Menu -->
    <div
      class="header-menu-wrapper header-menu-wrapper-left"
      ref="kt_header_menu_wrapper"
    >
      <div
        id="kt_header_menu"
        ref="kt_header_menu"
        class="header-menu header-menu-mobile"
      >
        <!-- example static menu here -->
        <KTMenu></KTMenu>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  &.dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import KTMenu from "../header/Menu";
import KTLayoutHeaderMenu from "@/assets/js/layout/base/header-menu.js";
export default {
  name: "KTSubheader",
  components: { KTMenu },
  data() {
    return { calendar: false };
  },
  props: {
    breadcrumbs: Array,
    title: String
  },
  mounted() {
    KTLayoutHeaderMenu.init(
      this.$refs["kt_header_menu"],
      this.$refs["kt_header_menu_wrapper"]
    );
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    dates: {
      get() {
        return this.$store.state.calendar.dates;
      },
      set(val) {
        this.$store.commit("calendar/setDates", val);
      }
    },
    dateRangeText() {
      return this.dates
        .map(el => {
          const [year, month, day] = el.split("-");
          return `${day}/${month}/${year}`;
        })
        .join(" - ");
    },
    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },

    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }
      }
      return classes.join(" ");
    }
  }
};
</script>
